import { provideHttpClient, withFetch, withInterceptors } from '@angular/common/http';
import {
	ApplicationConfig, ErrorHandler, importProvidersFrom, inject, provideAppInitializer,
	provideZoneChangeDetection
} from '@angular/core';
import { BrowserModule } from '@angular/platform-browser';
import { provideAnimations } from '@angular/platform-browser/animations';
import { provideRouter, withComponentInputBinding, withHashLocation } from '@angular/router';
import { environment } from '@environments/environment';
import { appRoutes } from '@infodocs/app.routes';
import { CompanyService } from '@infodocs/company/company.service';
import {
	UserPilotEventLoggerServiceService
} from '@infodocs/shared/modules/event-logging/user-pilot-event-logger.service.service';
import { authInterceptor } from '@infodocs/shared/interceptors/auth.interceptor';
import GoogleTagManagerEventLoggerService from '@infodocs/shared/modules/event-logging/google-tag-manager-event-logger.service';
import SentryEventLoggerService from '@infodocs/shared/modules/event-logging/sentry-event-logger.service';
import { REMOTE_EVENT_LOGGER_REPOSITORIES } from '@infodocs/shared/modules/event-logging/token';
import { urlAdjusterInterceptor } from '@infodocs/shared/interceptors/url-adjuster.interceptor';
import { modalDemoHttpInterceptor } from '@infodocs/public/pages/modal-demo-page/modal-demo-http.interceptor';
import { createErrorHandler, TraceService } from '@sentry/angular';
import { MODAL_CONFIG_DEFAULT_OVERRIDE, ModalModule } from 'ngx-bootstrap/modal';

export const appConfig: ApplicationConfig = {
	providers: [
		provideRouter(
			appRoutes,
			withComponentInputBinding(),
			...(window.location.href.includes('af-south-1-an') ? [withHashLocation()] : [])
		),
		provideHttpClient(
			withFetch(),
			withInterceptors([
				urlAdjusterInterceptor,
				modalDemoHttpInterceptor,
				authInterceptor
			])
		),
		provideZoneChangeDetection(),
		importProvidersFrom(ModalModule, BrowserModule),
		provideAnimations(),
		provideAppInitializer(() => {
			// skip clearing cache on staging.
			if (environment.environmentName !== 'staging') {
				try {
					localStorage.removeItem(CompanyService.COMPANIES_LIST);
				} catch {
					// localStorage can throw (e.g. Safari private browsing, cross-origin iframe embedding);
					// this cache clear is best-effort and must not block app bootstrap.
				}
			}
		}),
		provideAppInitializer(() => {
			inject(TraceService);
		}),
		{
			provide: 'googleTagManagerId',
			useValue: environment.gtmId
		},
		{
			provide: ErrorHandler,
			useValue: createErrorHandler()
		},
		{
			provide: REMOTE_EVENT_LOGGER_REPOSITORIES,
			useClass: GoogleTagManagerEventLoggerService,
			multi: true
		},
		{
			provide: REMOTE_EVENT_LOGGER_REPOSITORIES,
			useClass: SentryEventLoggerService,
			multi: true
		},
		{
			provide: REMOTE_EVENT_LOGGER_REPOSITORIES,
			useClass: UserPilotEventLoggerServiceService,
			multi: true
		},
		{
			provide: MODAL_CONFIG_DEFAULT_OVERRIDE,
			useFactory: () => ({ class: 'modal-xl' })
		}
	]
};
